import React, { useEffect, useState } from 'react';
import { Bell } from 'lucide-react';
const NAMES = ['María', 'Juan', 'Carlos', 'Ana', 'Laura', 'Diego', 'Sofía', 'Martín', 'Lucía', 'Pablo', 'Florencia', 'Marta', 'Graciela', 'Jorge', 'Silvia'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'Santa Fe', 'Mar del Plata', 'Salta', 'La Plata', 'Neuquén', 'San Juan', 'Resistencia'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaseData, setPurchaseData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const interval = setInterval(() => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setPurchaseData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 4000);
    }, 30000);
    return () => clearInterval(interval);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-in slide-in-from-bottom-5 fade-in duration-500" data-id="element-248">
      <div className="bg-white border border-orange-200 shadow-2xl rounded-lg p-4 flex items-center gap-3 max-w-xs" data-id="element-249">
        <div className="bg-teal-100 p-2 rounded-full" data-id="element-250">
          <Bell className="w-5 h-5 text-teal-600" data-id="element-251" />
        </div>
        <div data-id="element-252">
          <p className="text-sm text-slate-700" data-id="element-253">
            <span className="font-bold text-slate-900" data-id="element-254">
              {purchaseData.name}
            </span>{' '}
            de {purchaseData.city}
          </p>
          <p className="text-xs text-teal-600 font-medium mt-0.5" data-id="element-255">
            acaba de comprar Mente Activa
          </p>
        </div>
      </div>
    </div>;
}